function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { TableCell } from '../atom/cell';
import { useTableImplement } from '../implements/implement';
import { useSummaryRowContext, useSummaryContext } from './context';
export function TableSummaryCell(props) {
  var _props$rowSpan = props.rowSpan,
      rowSpan = _props$rowSpan === void 0 ? 1 : _props$rowSpan,
      _props$colSpan = props.colSpan,
      colSpanProp = _props$colSpan === void 0 ? 1 : _props$colSpan;

  var _useTableImplement = useTableImplement(),
      isTable = _useTableImplement.isTable;

  var _useSummaryContext = useSummaryContext(),
      stickyStartList = _useSummaryContext.stickyStartList,
      stickyEndList = _useSummaryContext.stickyEndList,
      widthList = _useSummaryContext.widthList,
      whitespaceGrid = _useSummaryContext.whitespaceGrid;

  var _useSummaryRowContext = useSummaryRowContext(),
      stickyTop = _useSummaryRowContext.stickyTop,
      _useSummaryRowContext2 = _useSummaryRowContext.rowIndex,
      rowIndex = _useSummaryRowContext2 === void 0 ? 0 : _useSummaryRowContext2,
      previousColIndexRef = _useSummaryRowContext.previousColIndexRef;

  var previousColIndex = previousColIndexRef.current;
  var rowArray = whitespaceGrid[rowIndex] || [];
  var colIndex = rowArray.findIndex(function (i) {
    return i === undefined;
  });

  if (colIndex === -1) {
    colIndex = rowArray.length;
  }

  for (var row = rowIndex; row < rowIndex + rowSpan; row++) {
    var _rowArray = whitespaceGrid[row];

    if (!_rowArray) {
      _rowArray = [];
      whitespaceGrid[row] = _rowArray;
    }

    for (var i = colIndex; i < colIndex + colSpanProp; i++) {
      _rowArray[i] = i;
    }
  }

  var stickyStart = stickyStartList[colIndex];
  var stickyEnd = stickyEndList[colIndex + colSpanProp - 1];
  var width = 0;

  if (!isTable) {
    for (var _i = colIndex; _i < colIndex + colSpanProp; _i++) {
      width += widthList[_i];
    }
  }

  var height = "".concat(rowSpan * 100, "%");
  var offset = 0;

  if (!isTable) {
    for (var _i2 = previousColIndex + 1; _i2 < colIndex; _i2++) {
      offset += widthList[_i2];
    }
  }

  previousColIndexRef.current = colIndex + colSpanProp - 1;
  return React.createElement(TableCell, _objectSpread(_objectSpread({}, props), {}, {
    rowSpan: rowSpan,
    header: "row",
    stickyTop: stickyTop,
    stickyStart: stickyStart === null || stickyStart === void 0 ? void 0 : stickyStart.value,
    stickyEnd: stickyEnd === null || stickyEnd === void 0 ? void 0 : stickyEnd.value,
    width: width,
    offset: offset,
    height: height
  }));
}